import axios from "axios";
import { getApiV1Base } from "@/services/apiConfig";

const client = axios.create({
  baseURL: `${getApiV1Base()}/auth`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export const authService = {
  login(email, password) {
    return client.post("/login", { email, password });
  },
  register(body) {
    const b = body || {};
    const fn =
      typeof b.first_name === "string" && b.first_name.trim()
        ? b.first_name.trim()
        : "User";
    const ln =
      typeof b.last_name === "string" && b.last_name.trim()
        ? b.last_name.trim()
        : "-";
    return client.post("/register", {
      email: b.email,
      password: b.password,
      first_name: fn,
      last_name: ln,
      phone: b.phone ?? null,
    });
  },
  verifyEmail(body) {
    return client.post("/verify-email", body);
  },
};
